// extracted by mini-css-extract-plugin
export default {"root":"RichTextarea_root__JoTnM","container":"RichTextarea_container__KHudn","textarea":"RichTextarea_textarea__u6Q2u","textContainer":"RichTextarea_textContainer__+-G5w"};